import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyB3h0XBhzxPRydFDkk9lMTHwU3XmpK-3w8',
  authDomain: 'portfolio-860c7.firebaseapp.com',
  projectId: 'portfolio-860c7',
  storageBucket: 'portfolio-860c7.appspot.com',
  messagingSenderId: '1094281530254',
  appId: '1:1094281530254:web:caba4d9b9bcf72724732df',
};

//init firebase
firebase.initializeApp(firebaseConfig);

//init firestore services
const projectFirestore = firebase.firestore();
const projectStorage = firebase.storage();

export { projectFirestore, projectStorage };
